const state = {
  listaEventDiscounts: [],
  eventDiscount: {
    id: null,
    descricao: "",
    evento: { id: null },
    tipo: { id: null },
    tipoRegistro: { id: null },
    percentualDesconto: 0,
    valorDesconto: "",
    ativo: true,
  },
};

export default state;
